import { render, staticRenderFns } from "./bet-triple-combo-btn.vue?vue&type=template&id=fe3fa754&scoped=true"
import script from "./bet-triple-combo-btn.vue?vue&type=script&lang=js"
export * from "./bet-triple-combo-btn.vue?vue&type=script&lang=js"
import style0 from "./bet-triple-combo-btn.vue?vue&type=style&index=0&id=fe3fa754&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe3fa754",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fe3fa754')) {
      api.createRecord('fe3fa754', component.options)
    } else {
      api.reload('fe3fa754', component.options)
    }
    module.hot.accept("./bet-triple-combo-btn.vue?vue&type=template&id=fe3fa754&scoped=true", function () {
      api.rerender('fe3fa754', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tai-xiu/bet-triple-combo-btn.vue"
export default component.exports